import React from 'react';

type InfoIconProps = React.SVGProps<SVGSVGElement>;

const InfoIcon: React.FC<InfoIconProps> = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 256 256"
    width={props.width || '1em'}
    height={props.height || '1em'}
    {...props}
  >
    <path d="M128.001,19.99963a108,108,0,1,0,108,108A108.12186,108.12186,0,0,0,128.001,19.99963Zm0,192a84,84,0,1,1,84-84A84.09561,84.09561,0,0,1,128.001,211.99963Zm20-36a12.00059,12.00059,0,0,1-12,12h-8a12.00059,12.00059,0,0,1-12-12V135.317a12.00216,12.00216,0,0,1,4-23.31739h8a12.0006,12.0006,0,0,1,12,12v40.68262A12.00513,12.00513,0,0,1,148.001,175.99963ZM110,84a16,16,0,1,1,16,16A16.00008,16.00008,0,0,1,110,84Z" />
  </svg>
);

export default InfoIcon;
